import React from "react";

export const PicturePet = ({ url }) => {
  return (
    <div>
      {url != null && url.length > 0 ? (
        <>
          <img src={url} alt="Image" className="picture-pet" />
        </>
      ) : (
        <img
          src="https://media.istockphoto.com/vectors/thumbnail-image-vector-graphic-vector-id1147544807?k=20&m=1147544807&s=612x612&w=0&h=pBhz1dkwsCMq37Udtp9sfxbjaMl27JUapoyYpQm0anc="
          alt="Image"
          className="picture-pet"
        />
      )}
    </div>
  );
};
